module.exports = __webpack_public_path__ + "Roboto-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Light.woff
// module id = 92
// module chunks = 0